export const STORAGE = {
  browserUUID: 'browserUUID',
  clickStreamGuessToken: 'clickStreamGuessToken',
  underMaintenance: 'underMaintenance',
  userToken: 'userToken',
  organizationCode: 'organizationCode',
  tempToken: 'tempToken',
  ssoLogin: 'ssoLogin',
  remoteConstant: 'removeConstant'
};
